<template>
    <div class="login-out-box">
			<p>你已在其他地方登录</p>
			<p>请重新登录</p>
			<button @click="jumpToIndex">确认</button>
		</div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {},
   data(){
    	return{
					
        };
    },
  components:{},
  created: function() {},
	mounted: function() {
	},
	methods: {
	  jumpToIndex(){
			var url=window.location.href;
			if (url!=window.stockUrl) {
				window.location.href=window.stockUrl;
			} else {
				this.$emit('logouthide');
			}
		}
	}
};
</script>
<style lang="scss"  scoped="scoped">
@import "~scss/mixin";
div.login-out-box{
	background-color: $color-title;
	-webkit-border-radius:10px;
	-moz-border-radius:10px;
	border-radius: 10px;
	text-align: center;
	p{
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 16px;
		+p{
			margin-bottom: 32px;
		}
	}
	button {
            cursor: pointer;
            font-size: 18px;
            font-weight: bold;
            -webkit-text-shadow: 0 0 5px #c31e31;
            -moz-text-shadow: 0 0 5px #c31e31;
            -ms-text-shadow: 0 0 5px #c31e31;
            -o-text-shadow: 0 0 5px #c31e31;
            text-shadow: 0 0 5px #c31e31;
            color: #FFFFFF;
            display: inline-block;
            margin-bottom: 20px;
            width: 200px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            -webkit-border-radius: 46px;
            -moz-border-radius: 46px;
            border-radius: 46px;
            background: url(../images/submit_bg.png) no-repeat center center;
            @include linear-gradient(right, #ff3c42, #ff643a);
            &:hover,
            &:active {
                background: url(../images/submit_bg.png) no-repeat center center;
                @include linear-gradient(right, #f10911, #f25227);
            }
            &:disabled {
                cursor: not-allowed;
            }
   }

}
</style>


// WEBPACK FOOTER //
// src/components/loginOut.vue